import CustomField from 'elements/field/CustomField'
import DependentInput from 'elements/input/DependentInput'
import React from 'react'
import { SelectInput } from 'react-admin'
import { doNotTranslate } from 'util/misc'
import { SNOW_MODE_DYNAMIC, SNOW_PROVIDER_CHOICES } from './constants'

interface SnowDataProviderFieldProps {
  allowEdit: boolean
  style: React.CSSProperties
}

export const SnowDataProviderField: React.FC<SnowDataProviderFieldProps> = ({ allowEdit, style }) => {
  return (
    <DependentInput dependsOn="sam_snow_mode" value={SNOW_MODE_DYNAMIC}>
      <CustomField
        component={SelectInput}
        source="sam_snow_provider"
        name="sam_snow_provider"
        label="Snow Data Provider"
        choices={SNOW_PROVIDER_CHOICES.map((c) => ({ id: c.id, name: doNotTranslate(c.name) }))}
        disabled={!allowEdit}
        style={style}
      />
    </DependentInput>
  )
}
